import { useQuery } from 'react-query'
import hooks from '../../../hooks'
import { reverse, sortBy } from 'lodash'

const useYearCourses = ({
    userId
}) => {
    const cacheKeys = hooks.useCacheKeys()
    const { api, endpoints, url, time } = hooks.useApi()
    const {clearCache } = hooks.useCache({ key: [cacheKeys.COURSES, 'year', userId] })

    const {
        data,
        isLoading
    } = useQuery(
        [cacheKeys.COURSES, 'year', userId],
        () => api.get(url(endpoints.userYearCourses, { userId} )),
        {
            staleTime: time.MINUTE,
            enabled: Boolean(userId)
        }
    )

    const courses = reverse(sortBy(data || [], ['date', 'hour', 'duration']))

    return {
        isLoading,
        courses,
        refresh: clearCache
    }
}

export default useYearCourses
